<template>
    <div class="d-flex flex-column">
        <small class="text-secondary mb-2">Доступные для работы муниципалитеты:</small>
        <div class="d-flex flex-wrap">
            <div v-for="(availableMunicipality, i) in userOrganizationMunicipalityNames" :key="'avmun-' + i" class="mb-3">
                <span class="tag tag-selectable"
                      :class="{'selected': selectedMunicipality && availableMunicipality['id'] === selectedMunicipality['id']}"
                      @click="onMunicipalityClick(availableMunicipality)">{{ availableMunicipality['short_name'] }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "MapMunicipalityList",
    props: {
        selectedMunicipality: { type: Object, default: () => { return {} } },
        editable: { type: Boolean, default: true }
    },
    computed: {
        ...mapGetters(['userOrganizationMunicipalityNames'])
    },
    methods: {
        onMunicipalityClick(item) {
            if (this.editable) {
                this.$emit('on-municipality-click', item)
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/theme/variables';

    .tag {
        background-color: #d6eaff;
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px
    }

    .tag-selectable {
        cursor: pointer;
        &.selected {
            background-color: $medium;
            color: white;
        }
    }
</style>